import { render, staticRenderFns } from "./increment_box.vue?vue&type=template&id=49d0b9e6&scoped=true&"
import script from "./increment_box.vue?vue&type=script&lang=js&"
export * from "./increment_box.vue?vue&type=script&lang=js&"
import style0 from "./increment_box.vue?vue&type=style&index=0&id=49d0b9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d0b9e6",
  null
  
)

export default component.exports